import { ConvergeButton } from '../../../presentation';
import { useUpsertSubmissionMutation } from '@converge/graphql';
import { useUnderwritingSubmissionStateContext } from '../underwriting.submission.context';

export const UnderwritingQuoteUpdateSubmissionStatusButton = () => {
  const { upsertSubmission, loading } = useUpsertSubmissionMutation();
  const {
    submission,
    info: {
      submissionStatusIsWrong,
      nextSubmissionStatus,
      nextSubmissionSubStatus,
    },
  } = useUnderwritingSubmissionStateContext();

  return (
    <ConvergeButton
      label={
        nextSubmissionStatus
          ? `Set submission status to ${nextSubmissionStatus}`
          : 'Update submission status'
      }
      disabled={!submissionStatusIsWrong}
      loading={loading}
      onClick={async () => {
        await upsertSubmission({
          variables: {
            details: {
              uuid: submission.uuid,
              status: nextSubmissionStatus,
              subStatus: nextSubmissionSubStatus,
            },
          },
        });
      }}
    />
  );
};
